/* eslint-disable react-hooks/exhaustive-deps */
import { QuestionVerifyResponse } from "../../utils/Types";
import { QuestionListAction } from "../../Redux/Actions/QuestionVerifyAction";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Spinner from "../DefaultComponent/Spinner";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { Button, Pagination, Stack, Tooltip } from "@mui/material";
import {
  calculateTotalPages,
  convertUTCToLocal,
  toSentenceCase,
} from "../../utils/Helper";
import QuestionVerificationModal from "./QuestionVerificationModal";
import BulkUploadModal from "./BulkUploadModal";
import { useNavigate, useSearchParams } from "react-router-dom";

export const QuestionsVerify = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const QuestionListState = useSelector(
    (state: any) => state?.QuestionListState
  );

  const [urlParams] = useSearchParams();

  const [list, setList] = useState<QuestionVerifyResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [modalData, setModalData] = useState<{
    open: boolean;
    id: number | null;
    type: string | null;
  }>({ open: false, id: null, type: null });
  const [count, setCount] = useState<number>(0);
  const [rowsPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(Number(urlParams?.get("page")));
  const [bulkUploadModalOpen, setBulkUploadModalOpen] = useState<boolean>(false);

  useEffect(() => {
    const params = `admin-list/que-validation/?page=${page}&visibility=PUBLIC,CONTEST`;
    dispatch(QuestionListAction(params));
  }, [page]);

  useEffect(() => {
    if (!QuestionListState?.loading) {
      setLoading(false);
      if (QuestionListState?.data?.row) {
        setList(QuestionListState?.data?.row);
        setCount(QuestionListState?.data?.total_count);
      }
    } else {
      setLoading(true);
    }
  }, [QuestionListState]);

  return (
    <>
      {loading && <Spinner />}
      {modalData?.open && (
        <QuestionVerificationModal
          setIsOpen={(value: boolean) =>
            setModalData({ ...modalData, open: value })
          }
          modalData={modalData}
        />
      )}
      <BulkUploadModal
        open={bulkUploadModalOpen}
        onClose={() => setBulkUploadModalOpen(false)}
      />
      <div
        className="page-wrapper card"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="col-md-12 d-flex justify-content-between align-items-center">
          <Breadcrumb
            pageTitle="Verify Questions"
            breadcrumbs={[
              {
                label: "Verify Questions",
                path: "/verify-questions",
                isActive: true,
              },
            ]}
          />
          <Button 
            variant="contained"
            onClick={() => setBulkUploadModalOpen(true)}
            sx={{
              backgroundColor: "#0555c8",
              "&:hover": { backgroundColor: "#043c99" },
              ml: "auto",
              mr: 2,
            }}
          >
            Bulk Upload Questions
          </Button>
        </div>
        <div
          className="row"
          style={{ width: "100%", display: "flex", flexWrap: "nowrap" }}
        >
          <div className={`m-2 table-full-container"}`} style={{ flex: 1 }}>
            <div className="card">
              <div className="table-responsive">
                <table className="table">
                  <thead className="table-dark">
                    {list?.length > 0 ? (
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Question Status</th>
                        <th scope="col">Visibility Status</th>
                        <th scope="col">Title</th>
                        <th scope="col">Question Type</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Created At</th>
                        <th scope="col">Actions</th>
                      </tr>
                    ) : (
                      <tr></tr>
                    )}
                  </thead>
                  <tbody>
                    {list?.length > 0 ? (
                      list?.map((question, index) => (
                        <tr
                          key={question?.id}
                          className="question-verify-table-data-row"
                        >
                          <td>{index + 1}.</td>
                          <td>
                            {toSentenceCase(
                              question?.question_details?.question_status
                            )}
                          </td>
                          <td>{toSentenceCase(question?.visiblity_status)}</td>
                          <td className="text-start">
                            <Tooltip
                              title={
                                question?.question_details?.title?.length > 30
                                  ? question?.question_details?.title
                                  : ""
                              }
                            >
                              <span>
                                {question?.question_details?.title?.length > 30
                                  ? question?.question_details?.title.slice(
                                      0,
                                      27
                                    ) + "..."
                                  : question?.question_details?.title}
                              </span>
                            </Tooltip>
                          </td>
                          <td>{question?.question_details?.question_type}</td>
                          <td className="question-verify-table-data-row-org-logo-container">
                            {question?.question_details?.created_by?.logo ? (
                              <img
                                className="question-verify-table-data-row-org-logo"
                                src={
                                  question?.question_details?.created_by?.logo
                                }
                                alt="Question created on Skillbrew.AI"
                              />
                            ) : (
                              <span className="mdi mdi-user"></span>
                            )}
                            {question?.question_details?.created_by?.email}
                          </td>
                          <td>{convertUTCToLocal(question?.created_at)}</td>
                          <td>
                            <button
                              className="primary-btn"
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                setModalData({
                                  open: true,
                                  id: question?.question_details?.id,
                                  type: question?.question_details
                                    ?.question_type,
                                });
                              }}
                            >
                              Review
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="w-100"> No data</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="pagination-style">
          <Stack spacing={2}>
            <Pagination
              count={calculateTotalPages(count, rowsPerPage)}
              color="primary"
              variant="outlined"
              shape="rounded"
              page={page}
              onChange={(e: any, newPage) => {
                setPage(newPage);
                navigate(`?page=${newPage}`);
              }}
            />
          </Stack>
        </div>
      </div>
    </>
  );
};

export default QuestionsVerify;
